import classes from './TableHeader.module.css'
const TableHeader: React.FC = ()=>{

    return(
        <div className={`row mx-0 ${classes.titleContainer}`}>
            <div className='col-3'style={{boxSizing: 'border-box'}}>
                <p className={classes.pTitle}>تقديمات</p>
            </div>
            <div className='col-3'style={{boxSizing: 'border-box'}}>
                <p className={classes.pTitle}>الحالة</p>
            </div>
            <div className='col-6'style={{boxSizing: 'border-box'}}>
                <p className={[classes.pTitle, classes.rightP].join(' ')}>الوظيفة</p>
            </div>
        </div>
    )
}

export default TableHeader